import { isApiClientError } from "@nudgebox/api-client";
import { MutationCache, QueryClient } from "@tanstack/react-query";
import { toast } from "@nudgebox/ui";
import { errorMessage } from "@/lib/errors.ts";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        // Don't retry client errors (401/403/404/validation); do retry flaky network/5xx once.
        retry: (failureCount, error) =>
          failureCount < 1 && !(isApiClientError(error) && error.status >= 400 && error.status < 500),
      },
    },
    mutationCache: new MutationCache({
      // One consistent failure surface for every mutation; screens can still
      // render field-level errors from the same error object.
      onError: (error, _variables, _context, mutation) => {
        if (mutation.options.meta?.silentError) return;
        toast.error("Action failed", errorMessage(error));
      },
    }),
  });
}

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: { silentError?: boolean };
  }
}
